export default __webpack_public_path__ + "images/ab4772e30072f2a04f290e8daad1ae02.svg";